<template>
  <el-dialog
    :title="title"
    :visible.sync="WarningInfoDialogClient"
    width="80%"
    top="5vh"
    :before-close="doClose"
    :modal-append-to-body="false"
  >
    <div class="DeviceDiv">
      <el-row :gutter="24">
        <el-col :md="6" :sm="6" :xs="24" class="left">
          <div class="alarm-info">
            <div>
              <span>{{ $t("desc.customerName") }}</span
              >{{ AlarmInfo.customerName }}
            </div>
            <div>
              <span>{{ $t("title.region") }}</span
              >{{ AlarmInfo.customerRegionName }}
            </div>
            <div>
              <span>{{ $t("title.customerCenter") }}</span
              >{{ AlarmInfo.customerCenterRegionName }}
            </div>
          </div>
          <div class="info">
            <div>
              <span>{{ $t("desc.airCompressorSN") }}</span
              >{{ AlarmInfo.dsn }}
            </div>
            <div>
              <span>{{ $t("title.productCategories") }}</span
              >{{ AlarmInfo.productBig }}
            </div>
            <div>
              <span>{{ $t("title.smallClassProduct") }}</span
              >{{ AlarmInfo.productSmall }}
            </div>
            <div>
              <span>{{ $t("title.machineType") }}</span
              >{{ AlarmInfo.productType }}
            </div>
            <div>
              <span>{{ $t("title.airCompressorService") }}</span>
              {{ AlarmInfo.serviceType }}
            </div>
            <div>
              <span>{{ $t("title.controllCcn") }}</span>
              {{ AlarmInfo.ccn }}
            </div>
            <div>
              <span>{{ $t("title.ccnVersion") }}</span>
              {{ AlarmInfo.ccnVersion }}
            </div>
            <div>
              <span>{{ $t("desc.compressorNumber") }}</span>
              {{ AlarmInfo.compressorNumber }}
            </div>
          </div>
        </el-col>
        <el-col :md="18" :sm="18" :xs="24" class="right">
          <el-row :gutter="24">
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <div class="block">
                <h4>{{ $t("title.alarmCode") }}</h4>
                <span style="color: #cf554a">{{ AlarmInfo.alarmCode }}</span>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <div class="block">
                <h4>{{ $t("title.alarmType") }}</h4>
                <span>{{
                  !AlarmInfo.alarmType?"":AlarmInfo.alarmType.toUpperCase().indexOf('TRIP') >-1 ? $t("title.trip") : $t("title.warning")
                }}</span>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12">
              <div class="block">
                <h4>{{ $t("title.alarmContent") }}</h4>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="activeLang == 'zh'? AlarmInfo.alarmContent : AlarmInfo.alarmContentEn"
                  placement="top-start"
                >
                  <span>{{ activeLang == 'zh'? AlarmInfo.alarmContent : AlarmInfo.alarmContentEn }}</span>
                </el-tooltip>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12">
              <div class="block">
                <h4>{{ $t("title.alarmTime") }}</h4>
                <span>{{ AlarmInfo.alarmTime }}</span>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12">
              <div class="block">
                <h4>{{ $t("title.relieveTime") }}</h4>
                <span>{{ AlarmInfo.relieveTime }}</span>
              </div>
            </el-col>
          </el-row>

          <div style="margin-top: 10px">
            <div
              class="echarts_Monitoring"
              style="border: 0; position: relative"
            >
              <el-tabs v-model="ActiveTab" type="border-card">
                <el-tab-pane :label="$t('title.expertAdvice')" name="suggest">
                  <template>
                    <div class="TabsTableDiv">
                      <el-table
                        :data="AlarmInfo.expertList"
                        stripe
                        style="width: 100%"
                        max-height="450"
                        :empty-text="$t('desc.noData')"
                      >
                        <el-table-column
                          type="index"
                          :label="$t('title.serialNumber')"
                          width="60px"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="reason"
                          :label="$t('desc.possibleCauseOfFailure')"
                          min-width="120px"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="solution"
                          :label="$t('desc.solution')"
                          min-width="120px"
                        >
                        </el-table-column>
                      </el-table>
                    </div>
                  </template>
                </el-tab-pane>
                <el-tab-pane :label="$t('desc.faultSnapshot')" name="snapshot">
                  <template>
                    <div class="timeBtn">
                      <el-select
                        multiple
                        filterable
                        collapse-tags
                        :placeholder="$t('title.selectFive')"
                        v-model="KTarget"
                        :multiple-limit="5"
                        @change="changeAlarmCode"
                        style="
                          width: 50%;
                          min-width: 200px;
                          margin-left: 6px;
                          float: right;
                        "
                      >
                        <el-option
                          v-for="item in alarmGatherOption"
                          :key="item.id"
                          :label="
                            activeLang == 'zh' ? item.gatherNameZH : item.gatherName
                          "
                          :value="item.gatherName"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div
                      class="echarts"
                      id="KchartTime4"
                      style="height: 350px; margin-top: 15px"
                      v-show="ActiveTab == 'snapshot'"
                    ></div>
                    <div style="position: relative; display: flex; right: 40px; justify-content: flex-end; font-size: 13px;">
                      <span @click="exportTripWarningMonitor()" style="cursor: pointer; text-decoration: underline;">{{ $t("desc.downloadDataDetails")}}</span>
                    </div>
                  </template>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getAlarmMonitor,
  getDeviceGatherList,
  exportTripWarningMonitorHalf,
  exportExcelNew
} from "../../../api/api";
export default {
  name: "index",
  props: {
    WarningInfoDialogClient: false,
    title: "",
    AlarmInfo: { alarmCode: "" },
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    })
  },
  
  data() {
    return {
      ActiveTab: "suggest",
      // 监控告警
      KTarget: "",
      echartIDAlarm: {},
      historyMonitor: {},
      alarmGatherOption: [],
      count: 0,
    };
  },
  watch: {
    WarningInfoDialogClient: {
      handler(newValue, oldValue) {
        if (newValue === false) {
          this.count = 0;
          this.ActiveTab = 'suggest';
          this.KTarget = [];
          if (this.echartIDAlarm.id) {
            this.echartIDAlarm.hideLoading();
            this.echartIDAlarm.clear();
          }
        }
      },
      deep: true,
    },
    ActiveTab: {
      handler(newValue, oldValue) {
        if (this.WarningInfoDialogClient) {
          this.count++;
          if (newValue === 'snapshot' && this.count == 1) {
            this.initMonitor();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    doClose() {
      console.log(this.AlarmInfo);
      this.$emit("dialogVisibleEvent", false, new Object());
    },
    async initMonitor() {
      await this.getDeviceGatherList();
      await this.getAlarmMonitor();
    },
    async getAlarmMonitor() {
      let that = this;
      that.historyMonitor = {};
      that.historyMonitor.chartDataList = new Array();
      that.historyMonitor.codeList = new Array();
      try {
        let res = await getAlarmMonitor(this.AlarmInfo.id);
        let kchart = this.$echarts.init(document.getElementById("KchartTime4"));
        this.echartIDAlarm = kchart;
        //展示echart loading
        kchart.showLoading({
          text: "loading",
          color: "#3A6BB5",
          textColor: "#000",
          maskColor: "#242731",
        });
        let data = res.result;
        that.historyMonitor = data;
        if (!data || data.chartDataList.length === 0) {
          kchart.hideLoading();
          this.echartIDAlarm.clear();
          return false;
        }
        that.drawChart();
      } catch (error) {
        
      }
    },
    changeAlarmCode(codeList) {
      let that = this;
      if (!that.historyMonitor || that.historyMonitor.chartDataList.length === 0) {
        return false;
      }
      that.drawChart();
    },
    drawChart() {
      let that = this;
      let totalData = {};
      totalData.chartDataList = new Array();
      totalData.codeList = new Array();
      totalData = that.historyMonitor;
      let selDataList = that.historyMonitor.chartDataList.filter((item) =>
        that.KTarget.some((aaa) => aaa === item.code)
      );
      totalData.chartDataList = selDataList;
      totalData.codeList = that.historyMonitor.codeList.filter((item) =>
        that.KTarget.some((aaa) => aaa === item)
      );
      //隐藏echart loading
      if (that.echartIDAlarm) {
        that.echartIDAlarm.hideLoading();
        this.$nextTick(() => {
          setTimeout(() => {
              that.initEchartsGsn(this.echartIDAlarm, totalData);
          }, 300);
        });
      }

    },
    async getDeviceGatherList() {
      console.log(this.AlarmInfo)
      let res = await getDeviceGatherList(this.AlarmInfo.dsn);
      this.alarmGatherOption = res.result;
      this.$nextTick(() => {
        if (
          this.alarmGatherOption.some(
            (aaa) => aaa.gatherName == "Compressor Discharge Temperature"
          )
        ) {
          this.KTarget.push("Compressor Discharge Temperature");
        }
        if (
          this.alarmGatherOption.some(
            (aaa) => aaa.gatherName == "Final Stage Discharge Temperature"
          )
        ) {
          this.KTarget.push("Final Stage Discharge Temperature");
        }
        if (
          this.alarmGatherOption.some(
            (aaa) => aaa.gatherName == "Compressor Discharge Pressure"
          )
        ) {
          this.KTarget.push("Compressor Discharge Pressure");
        }
        if(this.AlarmInfo.productLineType == "PAC"){
          if (
            this.alarmGatherOption.some(
              (aaa) => aaa.gatherName == "System Pressure"
            )
          ) {
            this.KTarget.push("System Pressure");
          }
        }
        if(this.AlarmInfo.productLineType == 'BV'){
          if (this.alarmGatherOption.some(a => a.gatherName == "Airend Discharge Pressure")) {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Airend Discharge Pressure");
            this.KTarget.push(code.gatherName);
          }
          if (this.alarmGatherOption.some(a => a.gatherName == "Airend Discharge Temperature")) {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Airend Discharge Temperature");
            this.KTarget.push(code.gatherName);
          }
          if (this.alarmGatherOption.some(a => a.gatherName == "Blower Inlet Pressure") && this.AlarmInfo.kPower == "BM200") {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Blower Inlet Pressure");
            this.KTarget.push(code.gatherName);
          }
          if (this.alarmGatherOption.some(a => a.gatherName == "Blower Inlet Temperature") && this.AlarmInfo.kPower == "BM200") {
            let code = this.alarmGatherOption.find(a => a.gatherName == "Blower Inlet Temperature");
            this.KTarget.push(code.gatherName);
          }
        }
      });
    },
    initEchartsGsn(id, echartData) {
      var Kchart1 = id;
      var startCount = 80;
      if (echartData && echartData.chartDataList.length > 0) {
        startCount = 100 - 6000 / echartData.chartDataList[0].dataList.length;
      }
      startCount < 0 ? 0 : startCount;
      startCount = 0;
      
      var Linecolor = ["#28739A", "#55B478", "#27508B", "#FFDE76", "#369089"];
      var Linecolor2 = [
        "rgba(0,117,155,0.05)",
        "rgba(0,182,125,0.05)",
        "rgba(3,81,139,0.05)",
        "rgba(255,222,118,0.05)",
        "rgba(54,144,137,0.05)",
      ];
      var seriesList = [];
      let codeListShow = new Array();
      for (let index = 0; index < echartData.codeList.length; index++) {
        let curCode = "";
        if (this.activeLang == "zh") {
          curCode = this.alarmGatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.nameZH;
        } else {
          curCode = this.alarmGatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.name;
        }
        codeListShow.push(curCode);
      }

      for (var i = 0; i < echartData.chartDataList.length; i++) {
        var temp = {
          name: echartData.codeList[i],
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 4,
          lineStyle: {
            normal: {
              color: Linecolor[i],
              width: 2,
            },
          },
          itemStyle: {
            borderColor: Linecolor[i],
            color: Linecolor[i],
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: Linecolor[i] },
                { offset: 1, color: Linecolor2[i] },
              ]),
            },
          },
          data: echartData.chartDataList.find(
            (item) => item.code === echartData.codeList[i]
          )?.dataList,
        };
        seriesList.push(temp);
      }

      var optionK = {
        legend: {
          data: codeListShow,
          textStyle: {
            color: "#828393",
            align: "left",
          },
          left: 0,
          top: 0,
          itemWidth: 16,
          itemHeight: 6,
          icon: "roundRect",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 150];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: (param) => {
            let str = "<div style='margin: 0px 0 0;line-height:1;'>"+
            "<div style='margin: 0px 0 0;line-height:1;'>"+
            "<div style='font-size:10px;color:#828393;font-weight:400;line-height:1;'>" + param[0].axisValue + "</div>" +
            "<div style='margin: 0px 0 0;line-height:1;'>";
            for (let index = 0; index < param.length; index++) {
              let curCode = "";
              if (this.activeLang == "zh") {
                curCode = this.alarmGatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.nameZH;
              } else {
                curCode = this.alarmGatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.name;
              }
              const element = param[index];
              const unit = echartData.chartDataList.find(
                (item) => item.code === element.seriesName
              )?.unit ?? "";
              str += "<div style='margin: 10px 0 0;line-height:1;'>" + 
              "<div style='margin: 0px 0 0;line-height:1;'>"+
              element.marker + 
              "<span style = 'font-size:10px;color:#828393;font-weight:400;margin-left:2px'>" + curCode + "</span>" + 
              "<span style='float:right;margin-left:20px;font-size:10px;color:#828393;font-weight:900'>"+ (element.value+"").parseNum() +"&nbsp" + unit +"<span>" +
              "<div style='clear:both'></div></div> <div style='clear:both'></div></div>"
            }
            str += "<div style='clear:both'></div></div> <div style='clear:both'></div></div> <div style='clear:both'></div></div>"
            return str;
          }
        },
        grid: {
          top: 60,
          left: 40,
          right: 40,
          bottom: 80,
        },
        dataZoom: [
          {
            show: true,
            height: 26,
            xAxisIndex: [0],
            bottom: 20,
            start: startCount,
            end: 100,
            textStyle: {
              color: "#A7B7CC",
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: [
          {
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
            data: echartData.dateTimeList,
          },
        ],

        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: seriesList,
      };

      Kchart1.setOption(optionK, true);

      window.addEventListener("resize", () => {
        Kchart1.resize();
      });
    },
    async exportTripWarningMonitor() {
      try {
        let that = this;
        let res = await exportTripWarningMonitorHalf(that.AlarmInfo.id);
        let data = res.result;

        let exportData = new Array();
        let titleList = [this.$t("title.Index")];
        titleList.push(...data.dateTimeList);
        exportData.push(titleList);
        let fileName =
          this.AlarmInfo.dsn +
          "_" +
          that.AlarmInfo.alarmTime
            .replace("-", "")
            .replace("-", "")
            .replace(":", "")
            .replace(":", "")
            .replace(" ", "") +
          "_" +
          that.AlarmInfo.alarmType.replace("on", "") +
          "_" +
          that.AlarmInfo.alarmCode +
          ".xlsx";
        data.detailList.forEach((element) => {
          let rowData = [element.name];
          element.dataList.forEach((item) => {
            rowData.push(item);
          });
          exportData.push(rowData);
        });
        exportExcelNew(exportData, fileName);
      } catch (error) {
        this.$message({
          showClose: true,
          message: error.error.message,

          type: "error",
        });
      }
    },
  },
  created() {},
};
</script>
 
 <style lang="less" scoped>
   .DeviceDiv .block span { 
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
 </style>